import { checkAgreedTNC } from '@/util/validation'

export default {
  data() {
    return {
      rules: {
        tradingPlatform: [
          {
            required: true,
            trigger: 'change',
            message: this.$t('openAdditAcc.platErr'),
          },
        ],
        accountType: [
          {
            required: true,
            trigger: 'change',
            message: this.$t('openAdditAcc.accTypeErr'),
          },
        ],
        currency: [
          {
            required: true,
            trigger: 'change',
            message: this.$t('openAdditAcc.currError'),
          },
        ],
        checkStatus: [
          {
            validator: checkAgreedTNC,
            trigger: 'change',
          },
        ],
      },
      accountTypeList: {
        mt4: [],
        mt5: [],
      },
    }
  },
  computed: {
    tradingPlatformOptions() {
      return this.$config.openLiveAccount
        .choosePlatform(this.regulator)
        .filter(platform => this.accountTypeList[platform.value].length > 0)
    },
    accountTypeOptions() {
      return this.accountTypeList[this.form.tradingPlatform] ?? []
    },
    currencyOptions() {
      return this.$config.openLiveAccount.chooseCurrency(
        this.regulator,
        this.form.tradingPlatform,
        this.form.accountType,
        this.$store.state.common.countryCode,
        this.eligibleCurrency,
        this.showUsc
      )
    },
  },
  methods: {
    tradingPlatformOnChange(value) {
      this.form.tradingPlatform = value
      this.form.accountType = null
      this.form.currency = null
    },
    accountTypeOnChange(value) {
      this.form.accountType = value
      this.form.currency = null
    },
    escapeStringForJSON(string) {
      return string.replace(/</g, '&lt;').replace(/>/g, '&gt;')
    },
  },
}
